/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import HappyToothGraphic from 'DesignSystem/Svgs/HappyToothGraphic/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Error({
  children,
  viewPath = "/DesignSystem/BrandLogo/Error",
  width = 80,
  height = 80
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<HappyToothGraphic
  viewPath={`${viewPath}/HappyToothGraphic`}
 alignSelf="center"
 marginLeft={dtSpaceXs}
 width={width}
 height={height}
/>
{children}
</React.Fragment>)
}